
import { ContentTopBar } from 'components';
import DisclaimerEditor from 'features/cms/components/global-disclaimer/disclaimer-editor';
import { Outlet } from 'react-router-dom';


export const GlobalDisclaimerView = () => {

    return (
        <>
            <ContentTopBar
                title={"Global Disclaimer"}
            />

            <DisclaimerEditor />
            <Outlet />
        </>
    );
};


